import { RetailEcommercePageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function RetailEcommerce() {
  return (
    <RetailEcommercePageProvider>
      <IndustryPageLayout />
    </RetailEcommercePageProvider>
  );
}
